import {
  Platform,
  TVFocusGuideView,
  View,
  type ViewProps,
} from 'react-native';

type FocusGuideProps = ViewProps & {
  /** Routes focus to the nearest focusable child when focus enters the guide. */
  autoFocus?: boolean;
  destinations?: unknown[];
  trapFocusUp?: boolean;
  trapFocusDown?: boolean;
  trapFocusLeft?: boolean;
  trapFocusRight?: boolean;
};

/**
 * Cross-platform wrapper around tvOS/Android-TV `TVFocusGuideView`.
 *
 * On TV it renders the native focus guide. On web (react-native-web) the
 * component does not exist, so we render a plain `View` and drop the TV-only
 * props to avoid passing unknown attributes to the DOM.
 */
export function FocusGuide({
  autoFocus,
  destinations,
  trapFocusUp,
  trapFocusDown,
  trapFocusLeft,
  trapFocusRight,
  ...rest
}: FocusGuideProps) {
  if (!Platform.isTV || TVFocusGuideView == null) {
    return <View {...rest} />;
  }

  return (
    <TVFocusGuideView
      autoFocus={autoFocus}
      destinations={destinations as never}
      trapFocusUp={trapFocusUp}
      trapFocusDown={trapFocusDown}
      trapFocusLeft={trapFocusLeft}
      trapFocusRight={trapFocusRight}
      {...rest}
    />
  );
}
